import { IconButtonStyled } from '@/components/IconButton/styled';

interface IProps {
  children?: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
  cursorPointer?: boolean;
}

export default function IconButton(props: IProps) {
  return (
    <IconButtonStyled
      style={{ cursor: props.onClick || props.cursorPointer ? 'pointer' : 'default' }}
      onClick={props.onClick}
      className={props.selected ? 'selected' : ''}
    >
      {props.children}
    </IconButtonStyled>
  );
}
